import React from 'react';
import { isValidKey } from 'utils/keyboard';
import { transformTime } from './transformDateTime';
import TextForm from '../TextForm';

export default React.forwardRef(
  ({ value, errors, autofocus, label, placeholder, ...props }: any, ref) => {
    return (
      <TextForm
        {...props}
        ref={ref}
        onChange={(e: any) => {
          return props.onChange({
            ...e,
            target: { ...e.target, value: transformTime(e.target.value, value) },
          });
        }}
        label={label}
        placeholder={placeholder}
        value={value}
        onKeyDown={(e: any) => isValidKey(e)}
        errors={errors}
        autofocus={autofocus}
      />
    );
  },
);
